exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fw-bold[data-v-8e1ec078],h2[data-v-8e1ec078],h3[data-v-8e1ec078],h5[data-v-8e1ec078]{font-weight:700}div[data-v-8e1ec078]{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8e1ec078","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/PrivacyAndPolicy.vue
// module id = 549
// module chunks = 0